import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

const BannerDiv = styled.div`
  padding: 5px;
  background: ${props => props.bg};
  display: flex;
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
  @media only screen and (min-width: 480px) {
    padding: 10px 30px;
  }
`;
const Links = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  .nav { cursor: pointer; }
  a, .nav {
    font-family: Capricorn, sans-serif;
    font-size: 19px;
    color: #adadad;
    text-decoration: none;
    margin-right: 10px;
    text-transform: uppercase;
    letter-spacing: 2px;
    padding-bottom: 2px;
    border-bottom: 1px solid black;
    &:hover {
      color: #fa0068;
      padding-bottom: 2px;
      border-bottom: 1px solid #fa0068;
    }
    @media only screen and (min-width: 480px) {
      margin-right: 30px;
    }
  }
  .active {
    color: white;
    padding-bottom: 2px;
    border-bottom: 1px solid white;
  }
  .noMobile {
    margin-top: -4px;
    @media only screen and (max-width: 632px) {
      display: none;
    }
  }
`;
const Name = styled.div`
  font-size: 32px;
  > a {
    font-family: Capricorn, sans-serif;
    letter-spacing: 0.05em;
    color: white;
    text-transform: uppercase;
    text-decoration: none;
    &:hover {
      color: #fa0068;
    }
  }
  @media only screen and (min-width: 480px) {
    font-size: 38px;
  }
`;
const DarkMenu = styled.div`
  background: black;
  a {
    color: white;
    text-decoration: none;
    text-transform: uppercase;
  }
`;

class Banner extends Component {
  state = {
    open: false,
  };

  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };
  render() {
    const { config } = this.props;

    let categories = [].concat(...config.pieces.map(p => p.categories));
    categories = [...new Set(categories)];

    const { open } = this.state;
    return (
      <BannerDiv bg={config.colors.secondary.main}>
        <Links>
          <div className="nav"
            ref={node => { this.anchorEl = node; }}
            aria-owns={open ? 'menu-list-grow' : null}
            aria-haspopup="true"
            onClick={this.handleToggle}
          >
            Work
          </div>

          <Popper open={open} anchorEl={this.anchorEl} transition disablePortal>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{ transformOrigin: 'left top' }}
              >
                <DarkMenu>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList>
                      { categories.map((category, i) =>
                        <MenuItem onClick={this.handleClose} key={`menu${i}`}>
                          <NavLink to={`/category/${category}`}>
                            { category.replace(/-/g, " ") }
                          </NavLink>
                        </MenuItem>
                      )}
                    </MenuList>
                  </ClickAwayListener>
                </DarkMenu>
              </Grow>
            )}
          </Popper>
          <NavLink to="/about">About</NavLink>
          <div className="noMobile">
            <NavLink to="/exhibitions" activeClassName="active">Exhibitions</NavLink>
          </div>
        </Links>
        <Name>
          <NavLink exact to="/">{config.portfolio_name}</NavLink>
        </Name>
      </BannerDiv>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js